<template lang="html">
  <div class="col-12 tag-filters no-pad-both">
    <div class="filter-box-headline pointer" @click="$emit('close')">
      <h4>Filtre</h4>
      <span class="material-icons tag-filter-close-btn">close</span>
    </div>

    <h5 style="padding-left: 10px; font-size: 14px;">
      <strong>Vælg hvad du vil se på kort og lister:</strong>
    </h5>

    <span class="sr-only">Filtre for temaet's steder</span>

    <TagFilter
      v-show="activeFilters.indexOf('vehicleType') !== -1"
      :filter-array="vehicleTypeFilters"
      title="Køretøjstype"
      subtitle="Plads til bil eller handicapbus"
      icon="accessible"
      @filterToggled="filterPlaces"
    ></TagFilter>

    <TagFilter
      v-show="activeFilters.indexOf('price') !== -1"
      :filter-array="priceFilters"
      title="Parkeringsforhold"
      subtitle="Gratis eller betalingsparkering"
      icon="local_atm"
      @filterToggled="filterPlaces"
    ></TagFilter>

    <!--<TagFilter
      v-show="activeFilters.indexOf('timeLimit') !== -1"
      :filter-array="timeLimitFilters"
      title="Tidsbegrænsninger"
      subtitle="Hvor længe kan du parkere"
      icon="access_time"
      @filterToggled="filterPlaces"
    ></TagFilter>-->
  </div>
</template>

<script>
import axios from "axios";
import TagFilter from "./TagFilter.vue";

export default {
  data() {
    return {
      activeFilters: [],
      vehicleTypeFilterIds: [],
      vehicleTypeFilters: [],
      priceFilters: [],
      priceFilterIds: [],
      timeLimitFilterIds: [],
      timeLimitFilters: [],
    };
  },
  props: {
    tagData: {
      required: true,
    },
  },
  components: {
    TagFilter,
  },
  watch: {
    tagData() {
      this.resetFilters();
    },
  },
  methods: {
    resetFilters() {
      this.activeFilters = [];
      this.vehicleTypeFilterIds = [];
      this.vehicleTypeFilters = [];
      this.priceFilters = [];
      this.priceFilterIds = [];
      this.timeLimitFilterIds = [];
      this.timeLimitFilters = [];

      this.generateFilters();
    },

    generateFilters() {
      for (var i = 0; i < this.$props.tagData.features.length; i++) {
        for (var k in this.$props.tagData.features[i].properties) {
          if (this.$props.tagData.features[i].properties[k].id == 106) {
            var typeFilter = this.$props.tagData.features[i].properties[k];
            if (this.activeFilters.indexOf("vehicleType") == -1) {
              this.activeFilters.push("vehicleType");
            }
          }
          if (this.$props.tagData.features[i].properties[k].id == 146) {
            var priceFilter = this.$props.tagData.features[i].properties[k];
            if (this.activeFilters.indexOf("price") == -1) {
              this.activeFilters.push("price");
            }
          }
          // if (this.$props.tagData.features[i].properties[k].id == 50) {
          //   var timeLimitFilter = this.$props.tagData.features[i].properties[k];
          //   if (this.activeFilters.indexOf("timeLimit") == -1) {
          //     this.activeFilters.push("timeLimit");
          //   }
          // }
        }
        //Vehicle type filters
        if (typeFilter !== undefined) {
          if (this.vehicleTypeFilterIds.indexOf(typeFilter.option_id) == -1) {
            this.vehicleTypeFilterIds.push(typeFilter.option_id);
            let dataHref = "OdenseRundt-FilterOption-vehicle-type-" + typeFilter.option_id;
            let options = { checked: false, href: dataHref, option_id: typeFilter.option_id, name: typeFilter.value };
            if (localStorage.getItem(dataHref) == undefined) {
              localStorage.setItem(dataHref, "true");
            }
            options.checked = localStorage.getItem(dataHref) == "false" ? false : true;
            this.vehicleTypeFilters.push(options);
          }
        }
        //Price filters
        if (priceFilter !== undefined) {
          if (this.priceFilterIds.indexOf(priceFilter.option_id) == -1) {
            this.priceFilterIds.push(priceFilter.option_id);
            let dataHref = "OdenseRundt-FilterOption-price-type-" + priceFilter.option_id;
            let options = { checked: false, href: dataHref, option_id: priceFilter.option_id, name: priceFilter.value };
            if (localStorage.getItem(dataHref) == undefined) {
              localStorage.setItem(dataHref, "true");
            }
            options.checked = localStorage.getItem(dataHref) == "false" ? false : true;
            this.priceFilters.push(options);
          }
        }
        //Time limit filters
        // Deactivated filter
        /*if (timeLimitFilter != undefined) {
          if (this.timeLimitFilterIds.indexOf(timeLimitFilter.option_id) == -1) {
            this.timeLimitFilterIds.push(timeLimitFilter.option_id);
          }
        }*/
      }
      //Insert time limit filters in the correct order according to content manager
      if (this.timeLimitFilterIds.length != 0) {
        axios
          .get("https://apps.odenserundt.dk/data/parkering/time_limit_order.php")
          .then((response) => {
            var timeLimitOrder = response.data;
            for (var j = 0; j < timeLimitOrder.length; j++) {
              var compareInt = parseInt(timeLimitOrder[j].id);
              if (this.timeLimitFilterIds.indexOf(compareInt) != -1) {
                let dataHref = "OdenseRundt-FilterOption-time-limit-" + timeLimitOrder[j].id;
                let options = { checked: false, href: dataHref, option_id: timeLimitOrder[j].id, name: timeLimitOrder[j].option };
                if (localStorage.getItem(dataHref) == undefined) {
                  localStorage.setItem(dataHref, "true");
                }
                options.checked = localStorage.getItem(dataHref) == "false" ? false : true;
                this.timeLimitFilters.push(options);
              }
            }
          })
          .catch(function(error) {
            console.log("Error getting time limit order", error);
          });
      }

      this.filterPlaces();
    },

    filterPlaces() {
      this.$root.$emit("toggleLoadingScreen", true);
      var tagDataFiltered = [];
      var tagDataDiscarded = [];
      for (var i = 0; i < this.tagData.features.length; i++) {
        var checkPassed = [];
        for (var a = 0; a < this.activeFilters.length; a++) {
          checkPassed[a] = this.checkFilterController(this.activeFilters[a], this.tagData.features[i]);
        }
        //console.log(this.tagData.features[i].name);
        if (checkPassed.indexOf(false) === -1) {
          //console.log(true);
          tagDataFiltered.push(this.tagData.features[i]);
        } else {
          //console.log(false);
          tagDataDiscarded.push(this.tagData.features[i]);
        }
      }
      /*console.log('Filtered:', tagDataFiltered);
      console.log('Discarded:', tagDataDiscarded);*/
      this.$emit("dataFiltered", tagDataFiltered);
      setTimeout(() => {
        this.$root.$emit("toggleLoadingScreen", false);
      }, 500);
    },
    //Filter controller
    checkFilterController(filter, feature) {
      var result;
      switch (filter) {
        case "price":
          result = this.checkPrice(feature);
          break;
        case "timeLimit":
          result = this.checkTimeLimit(feature);
          break;
        case "vehicleType":
          result = this.checkVehicleType(feature);
          break;
      }
      return result;
    },

    checkPrice(feature) {
      // if (feature.properties.prop49) {
      //   if (feature.properties.prop49.value.length > 5) {
      //     return true;
      //   } else {
      //     if (localStorage.getItem("OdenseRundt-FilterOption-price-0") == "true" && parseInt(feature.properties.prop49.value) == 0) {
      //       return true;
      //     } else if (localStorage.getItem("OdenseRundt-FilterOption-price-0") == "false" && parseInt(feature.properties.prop49.value) == 0) {
      //       //console.log(feature.name+': Gratis');
      //       return false;
      //     } else {
      //       if (
      //         localStorage.getItem("OdenseRundt-FilterOption-price-max-12") == "true" &&
      //         parseInt(feature.properties.prop49.value) <= 12 &&
      //         parseInt(feature.properties.prop49.value) != 0
      //       ) {
      //         return true;
      //       }
      //       if (localStorage.getItem("OdenseRundt-FilterOption-price-above-12") == "true" && parseInt(feature.properties.prop49.value) > 12) {
      //         return true;
      //       }
      //       if (localStorage.getItem("OdenseRundt-FilterOption-price-no-info") == "true" && feature.properties.prop49.value == "Ingen info") {
      //         return true;
      //       } else {
      //         //console.log(feature.name+': Ikke gratis');
      //         return false;
      //       }
      //     }
      //   }
      // }
      if (feature.properties.prop146) {
        for (var i = 0; i < this.priceFilterIds.length; i++) {
          if (
            localStorage.getItem("OdenseRundt-FilterOption-price-type-" + this.priceFilterIds[i]) == "true" &&
            feature.properties.prop146.option_id == this.priceFilterIds[i]
          ) {
            //console.log('Gokendt');
            return true;
          }
        }
        //console.log('Afvist');
        return false;
      }
      return false;
    },

    checkTimeLimit(feature) {
      if (feature.properties.prop50) {
        for (var i = 0; i < this.timeLimitFilterIds.length; i++) {
          if (
            localStorage.getItem("OdenseRundt-FilterOption-time-limit-" + this.timeLimitFilterIds[i]) == "true" &&
            feature.properties.prop50.option_id == this.timeLimitFilterIds[i]
          ) {
            //console.log('Gokendt');
            return true;
          }
        }
        //console.log('Afvist');
        return false;
      }
      //console.log(feature.name, feature.id, 'Afvist: Mangler property Tidsbegrænsning');
      return false;
    },

    checkVehicleType(feature) {
      if (feature.properties.prop106) {
        for (var i = 0; i < this.vehicleTypeFilterIds.length; i++) {
          if (
            localStorage.getItem("OdenseRundt-FilterOption-vehicle-type-" + this.vehicleTypeFilterIds[i]) == "true" &&
            feature.properties.prop106.option_id == this.vehicleTypeFilterIds[i]
          ) {
            //console.log('Gokendt');
            return true;
          }
        }
        //console.log(feature.name, 'Afvist - Køretøjstype');
        return false;
      }
      console.log(feature.name, feature.id, "Afvist: Mangler property Køretøjstype");
      return false;
    },
  },
};
</script>

<style lang="css" scoped>
.tag-filters {
  margin-top: 10px;
  margin-bottom: 10px;
  /*background-color: #f8f8f8;*/
  background-color: #fdfdfd;
}

h5 {
  font-size: 14px;
  padding: 10px;
  margin: 0px;
}

.tag-filters.filter-fullscreen {
  position: fixed;
  z-index: 990;
  left: 0px;
  bottom: -200px;
  margin-bottom: 0px;
  max-height: 200px;
  overflow-y: auto;
  border-top: 1px solid #ddd;
  border-bottom: none;
  -webkit-transition: 1.2s ease;
  -moz-transition: 1.2s ease;
  -o-transition: 1.2s ease;
  -ms-transition: 1.2s ease;
  transition: 1.2s ease;
}

.tag-filters.filter-fullscreen.show-filters {
  bottom: 0px !important;
}

.filter-box-headline {
  display: none;
  text-align: center;
}

.filter-box-headline h4,
.filter-box-headline .material-icons {
  display: inline-block;
}

.tag-filter-close-btn {
  position: absolute;
  right: 5px;
  top: 5px;
}

.tag-filters.filter-fullscreen .filter-box-headline {
  display: block;
}

.filter-btn {
  height: 30px;
  border-top: 1px solid #ddd;
  padding: 0px 5px 0px 5px;
  text-align: center;
  cursor: pointer;
}

.filter-btn .material-icons {
  vertical-align: middle;
}

@media screen and (orientation: portrait) {
  .tag-filters {
    border-bottom: 1px solid #ddd;
  }
}

@media screen and (max-width: 767px) and (orientation: landscape) {
  .tag-filters {
    margin-top: 10px;
    border-bottom: 1px solid #ddd;
  }
}

@media screen and (min-width: 768px) and (orientation: landscape) {
  .tag-filters {
    margin-top: 0px;
    border: 1px solid #ddd;
    border-top: none;
  }
}
</style>
